import { LoanPurpose } from './generated/graphql-types'

export enum RobinhoodRateSource {
  Sage = 'Sage',
  National = 'National',
}

export const RobinhoodLoanPurpose = ['purchase', 'refinance']

export const RH_LOAN_TYPE_TO_PURPOSE = {
  new: LoanPurpose.Purchase,
  refinance: LoanPurpose.Refinance,
  heloc: LoanPurpose.HomeEquity,
} as const

export type RhLoanType = keyof typeof RH_LOAN_TYPE_TO_PURPOSE

export enum RobinhoodEventType {
  RateLocked = 'rate_locked',
  ClearToClose = 'clear_to_close',
  Funded = 'funded',
  ApplicationCompleted = 'application_completed',
  NoteSigned = 'note_signed', // TODO: once Robinhood supports it, switch the Figure webhook send back to this value
}

// Wire contract for RH-stored deeplink URLs;
export enum RhDeeplinkFlow {
  HomeEquity = 'home-equity',
}
